import NavSideBar from "../component/NavSideBar";

export default function Border() {
  return (
    <NavSideBar>
        <div className="p-10 text-3xl font-bold">Border</div>
    </NavSideBar>
  )
}
